import React, { CSSProperties } from 'react';
import { Image, useDeviceType } from '@cian/ui-kit';

import { IArticlesMainAttributesRubricSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesRubricSchema';
import { IArticlesMainAttributesSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesSchema';
import { RubricButton } from './components/RubricButton';
import { formatDate } from '../../utils';
import * as s from './CardListItem.css';

export interface ICard
  extends Partial<Pick<IArticlesMainAttributesSchema, 'title' | 'image' | 'subtitle' | 'datePublish'>> {
  height?: CSSProperties['height'];
  children?: React.ReactNode;
  rubric?: IArticlesMainAttributesRubricSchema;
  onRubricButtonClick?(e: React.MouseEvent, url: IArticlesMainAttributesRubricSchema['url']): void;
  onClick?(e: React.MouseEvent): void;
}

/**
 * Компонент карточки в списке
 */
export const CardListItem = ({
  height,
  children,
  title,
  subtitle,
  image,
  rubric,
  datePublish,
  onRubricButtonClick,
  onClick,
}: ICard) => {
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';

  return (
    <div className={`${s['wrapper']}`} onClick={onClick} style={{ height }}>
      {!children && (
        <>
          {image && (
            <div className={`${s['image-wrapper']}`}>
              <Image
                alt={title}
                borderRadius={0}
                objectFit="cover"
                preloader
                src={image}
                theme="light"
                title={title}
                height={isPhone() ? 130 : 180}
              />
            </div>
          )}

          <div className={`${s['content-wrapper']} ${image ? s['_has-image'] : ''}`}>
            <div className={`${s['content-wrapper-inner']}`}>
              {rubric && (
                <div className={`${s['rubric-button-wrapper']}`}>
                  <RubricButton onClick={e => onRubricButtonClick && onRubricButtonClick(e, rubric.url)}>
                    {rubric.name.toLowerCase()}
                  </RubricButton>
                </div>
              )}

              {title && (
                <div className={`${s['title']}`} title={title}>
                  {title}
                </div>
              )}

              {subtitle && (
                <div className={`${s['subtitle']}`} title={subtitle}>
                  {subtitle}
                </div>
              )}

              {datePublish && <div className={`${s['date']}`}>{formatDate(new Date(datePublish))}</div>}
            </div>
          </div>
        </>
      )}

      {children}
    </div>
  );
};
